import { Loader } from 'Core/Components';
import PrivateRoutes from './PrivateRoutes';
import AuthPage from 'Views/Auth/AuthPage';
import { useAuth, normalizeUserType } from 'Utils/Hooks/useAuth';
import ErrorsPage from 'Views/Errors/ErrorPage';
import Logout from 'Views/Auth/Components/Logout';
import React, { Fragment, Suspense } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';

const Routers = () => {
  // Get current admin
  const { currentAdmin } = useAuth();

  // Function to check if the user type has access to a specific route
  const hasAccess = (routeUserType) => {
    return normalizeUserType(currentAdmin?.user_type) === routeUserType;
  };
  return (
    <BrowserRouter basename={'/'}>
      <Suspense fallback={<Loader />}>
        <Routes>
          {currentAdmin !== undefined && hasAccess('ADMIN') ? (
            // Render for undefined currentAdmin and user usertype
            <Fragment>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard/home' />} />
            </Fragment>
          ) : currentAdmin !== undefined && hasAccess('USER') ? (
            // Render for undefined currentAdmin and admin usertype
            <Fragment>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/partner/home' />} />
            </Fragment>
          ) : (
            // Default rendering when no condition is met
            <Fragment>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </Fragment>
          )}
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Routers;
